<template>
  <el-dialog
    title="拷贝规则"
    :visible.sync="dialogFormVisible"
    custom-class="custom_dialog"
    :close-on-click-modal="false"
  >
    <el-row>
      <el-col :span="22" :offset="1">
        <el-form
          :model="ruleForm"
          :rules="ruleFormRules"
          ref="ruleForm"
          label-width="130px"
          class="demo-ruleForm"
          size="mini"
          width="500px"
        >
          <el-form-item label="选择规则：" required>
            <el-select v-model="ruleForm.CopyRuleId" @change="$forceUpdate()">
              <el-option
                :label="ruleItem.Name"
                :value="ruleItem.Id"
                v-for="(ruleItem, ruleItemIndex) in rules"
                :key="ruleItemIndex"
              >
                <span style="float: left">{{ ruleItem.Name }}</span>
                <span
                  style="
                    float: right;
                    color: #8492a6;
                    font-size: 13px;
                    margin-left: 50px;
                  "
                  v-if="ruleItem.VoteNames.length > 0"
                >
                  {{ ruleItem.VoteNames[0] }}
                </span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="copyRule('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import voteRuleApi from '../../api/vote/voteRule'
export default {
  name: 'CopyRule',
  data () {
    return {
      ruleForm: {
        CopyRuleId: null
      },
      ruleFormRules: {
        CopyRuleId: [
          {
            validator: (rule, value, callback) => {
              console.log(value)
              if (value === '' || value === null) {
                callback(new Error('请选择要拷贝的规则！'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },
      rules: [],
      dialogFormVisible: false,
      meetingId: null
    }
  },
  props: {

  },
  methods: {
    getRulesByCompanyId: function () {
      const _this = this
      _this.openLoading()
      voteRuleApi.getRulesByCompanyId({
        RuleType: 2,
        MaxResultCount: 3000
      }).then(data => {
        _this.rules = data.Items
        // if (_this.rules.length > 0) {
        //   _this.ruleForm.CopyRuleId = _this.rules[0].Id
        // }
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    copyRule: function (formName) {
      const _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!_this.ruleForm.CopyRuleId) {
            _this.$message({
              showClose: true,
              type: 'error',
              message: '请选择要拷贝的规则！',
              customClass: 'custom_message'
            })
          } else {
            const openLoading = _this.openLoading('保存中…')
            voteRuleApi.copyRule({ MeetingId: _this.meetingId, CopyRuleId: _this.ruleForm.CopyRuleId }).then(data => {
              openLoading.close()
              _this.$message({
                showClose: true,
                type: 'success',
                message: '拷贝成功！',
                customClass: 'custom_message'
              })
              _this.dialogFormVisible = false
            }).catch(err => {
              openLoading.close()
              _this.dialogFormVisible = false
              return err
            })
          }
        } else {
          return false
        }
      })
    },
    openCopyRule: function (meetingId) {
      this.dialogFormVisible = true
      this.meetingId = meetingId
      this.getRulesByCompanyId()
    }
  },
  created () {

  }
}
</script>
<style lang="less">
</style>
